import { Injectable, Injector, inject } from '@angular/core';
import { PkceCode } from '../../models/login';
import { LoginPostWithContinueService } from '../../services/login/data-services/login-post-with-continue/login-post-with-continue-service';
import { LoginPostWithCredService } from '../../services/login/data-services/login-post-with-cred/login-post-with-cred-service';
import { LoginPostWithRememberUserService } from '../../services/login/data-services/login-post-with-remember-user/login-post-with-remember-user-service';
import { SwapAccessTokenService } from '../../services/login/data-services/swap-access-token/swap-access-token-service';
import { LoginRememberMeErrorUtilService } from '../../utils/login/login-remember-me-error-util.service';
import { LoginRememberMeUtilsService } from '../../utils/login/login-remember-me-utils.service';

@Injectable({
  providedIn: 'root'
})
export class PostWithCredentialsFacadeHelperService {
  loginPostWithCred = inject(LoginPostWithCredService);
  loginPostWithContinue = inject(LoginPostWithContinueService);
  loginPostWithRememberUser = inject(LoginPostWithRememberUserService);
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  LoginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  swapAccessToken = inject(SwapAccessTokenService);
  injector = inject(Injector);

  flowId = '';
  encyToken = '';
  uid = '';
  pkceCode = {} as PkceCode;
}
